import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import moment from 'moment'
import {Link} from 'react-router-dom'
import getCaseById from "../../utils/calendar";
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom'
import { ACTION_CREATORS as userCase } from '../../redux/reducers/cases';
import SimpleBackdrop from './Spinner';
import { ROLE_CASES } from '../../constants';
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { classes, order, orderBy, numSelected, rowCount, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow className={classes.tableHeader}>
        {props.columns.map((headCell) => (
          <TableCell
            key={headCell.field}
            align={headCell.numeric ? 'right' : 'left'}
            padding='default'
            sortDirection={orderBy === headCell.field ? order : false}

          >
            <TableSortLabel
              active={orderBy === headCell.field}
              direction={orderBy === headCell.field ? order : 'asc'}
              onClick={createSortHandler(headCell.field)}
            >
              {headCell.headerName}
              {/* {orderBy === headCell.field ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null} */}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      {numSelected > 0 ? (
        <Typography className={classes.title} color="inherit" variant="subtitle1" component="div">
          {numSelected} selected
        </Typography>
      ) : (
          <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
            Surgical Case
          </Typography>
        )}
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  // root: {
  //   width: '100%',
  // },
  // paper: {
  //   width: '100%',
  //   marginBottom: theme.spacing(2),
  // },
  table : {
    minWidth: 750,
  },

  whiteSpace: {
    whiteSpace:'nowrap'
  },
  

  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  tableHeader: {
    background: '#43FSDF'
  }
}));

export default function EnhancedTable(props) {
  const dispatch = useDispatch();
  let history = useHistory();
  const GetCaseById_Set = (response) => dispatch(userCase.setCaseDetail(response));
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    const pageNbr = Math.round(props.pageOffset/20);
    setPage(pageNbr);
  }, [props.pageOffset])

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    props.handlePageNumberNext(newPage)
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    // setPage(0);
  };


  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, props.case.length - page * rowsPerPage);
  const showPlus = props.filterObj?.role === ROLE_CASES.TEAM_CASES;
  const arr = [];
  const viewSurgicalCase = (externalId, sfId) => {
    setLoading(true)
    getCaseById(externalId, sfId)
    .then(res => {
      GetCaseById_Set(res.data);
      setLoading(false)
      history.push('/ViewSurgicalCase')
    })
  }

  const getChckeboxValue = (tprs, data1, data2) => (event) => {
    const value = event.target.checked;

    if (event.target.checked === true) {
      tprs.filter(data => {
        if (data.tpr_status === 'Treatment Plan Downloaded' || data.tpr_status === 'Treatment Plan Available') {
          let u = { 
            tprs: data.tpr_id,
            requestId: data.tpr_id,
            sfId: data2.sfId,
            external_id: data.external_id,
            caseId: data2.caseId
          };
         
          arr.push(u);
        }
      })
      
    
    }
    else {
      tprs.filter(data => {
       arr.filter((value, index) => {
        if (value.tprs === data.tpr_id) {
       arr.splice(index,1);
          return;
        }
       })
      })
    }

    localStorage.setItem("selectedCheckBoxes",JSON.stringify(arr));
}

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={'small'}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes.whiteSpace}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={props.case.length}
              columns={props.columns}
            />
            <TableBody>
              {stableSort(props.case, getComparator(order, orderBy))
                .slice(0 * rowsPerPage, 0 * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.name);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <TableRow
                  
                      hover
                      tabIndex={-1}
                      key={row.caseId}
                    >
                      <TableCell id={labelId} scope="row"   className={classes.whiteSpace}>
                      <Link onClick={() => {viewSurgicalCase(row.externalId, row.sfId)}} style={{ textDecoration: 'none', color: '#039be5' }}>{row.caseId}</Link>
                      </TableCell>
                      <TableCell align="left">{row.patientId != null ? row.patientId : ''}</TableCell>
                      <TableCell align="left">{row.status}</TableCell>
                      <TableCell align="left">{moment(row.surgeryDate).format('MM/DD/yyyy, hh:mm A')}</TableCell>
                      <TableCell align="left">{row.hospitalName}</TableCell>
                      <TableCell align="left">{row.surgeonName}</TableCell>
                      <TableCell align="left">{row.salesRep}</TableCell>
                      <TableCell align="left"> 
                     { row.downloadable == true ?  <input type="checkbox"
                     onClick={getChckeboxValue(row.tprs
                      , row.tprs,row)}
                     style={{ cursor: "pointer", marginLeft: "13px" }}></input> : <input type="checkbox" disabled style={{  marginLeft: "13px" }}></input>
                     
                  }</TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={showPlus? -1 : props.total}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[10,15,20]}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelDisplayedRows={({ from, to, count }) => {
            return `${from}-${to} of ${showPlus ? '1000+' : count}`;
          }}
        />
      </Paper>
      <SimpleBackdrop open={loading} />
    </div>
  );
}
